import { render, staticRenderFns } from "./Roles.vue?vue&type=template&id=cec7447e"
import script from "./Roles.vue?vue&type=script&lang=js"
export * from "./Roles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cec7447e')) {
      api.createRecord('cec7447e', component.options)
    } else {
      api.reload('cec7447e', component.options)
    }
    module.hot.accept("./Roles.vue?vue&type=template&id=cec7447e", function () {
      api.rerender('cec7447e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/roles/Roles.vue"
export default component.exports